module.exports = __webpack_public_path__ + "static/media/badge2.888d8f82.svg";